import { getApps, initializeApp } from 'firebase/app';
import { deleteToken, getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';

(function (angular) {
	angular.module('bizPartEngage').service('base.service', baseService);
	angular.module('bizPartEngage').service('bizNotificationService', bizNotificationService);
	angular.module('bizPartEngage').factory('bizFirebaseMessagingClient', bizFirebaseMessagingClient);
	angular.module('bizPartEngage').factory('bizPushNotificationBrowser', bizPushNotificationBrowser);
	angular.module('bizPartEngage').factory('bizPushNotificationApi', bizPushNotificationApi);
	angular.module('bizPartEngage').service('bizPushNotificationService', bizPushNotificationService);
	angular.module('bizPartEngage').service('bizRuntimeContainerService', bizRuntimeContainerService);
	angular.module('bizPartEngage').service('bizPageSurfaceService', bizPageSurfaceService);

	angular.module('bizPartEngage').service('MetadataService', [
		'$window',
		'$filter',
		function ($window, $filter) {
			var self = this;
			var ogImageElement = document.getElementById('og-image');
			var ogVideoElement = document.getElementById('og-video');
			var defaultOgImage = ogImageElement.getAttribute('data-default-content') || '';
			var defaultOgVideo = ogVideoElement.getAttribute('data-default-content') || '';
			var canonicalElement = document.getElementById('canonical-url');
			var canonicalOrigin = new URL(canonicalElement.href, location.href).origin;

			function setPropertyMetaTag(id, property, content) {
				var element = document.getElementById(id);
				if (!content) {
					if (element) element.parentNode.removeChild(element);
					return;
				}

				if (!element) {
					element = document.createElement('meta');
					element.id = id;
					element.setAttribute('property', property);
					document.head.appendChild(element);
				}
				element.content = content;
			}

			function normalizeDate(value) {
				if (!value) return null;
				var serializedDate = typeof value === 'string' && /^\/Date\((-?\d+)/.exec(value);
				var date = serializedDate ? new Date(parseInt(serializedDate[1], 10)) : new Date(value);
				return isNaN(date.getTime()) ? null : date.toISOString();
			}

			function setArticleMetadata(tagData, canonicalUrl, imageUrl) {
				var isArticle = tagData.type === 'article';
				var datePublished = isArticle ? normalizeDate(tagData.datePublished) : null;
				var dateModified = isArticle ? normalizeDate(tagData.dateModified) || datePublished : null;
				var author = isArticle ? tagData.author : null;

				setPropertyMetaTag('article-published-time', 'article:published_time', datePublished);
				setPropertyMetaTag('article-modified-time', 'article:modified_time', dateModified);
				setPropertyMetaTag('article-author', 'article:author', author);

				var structuredDataElement = document.getElementById('blogposting-jsonld');
				if (!isArticle) {
					if (structuredDataElement) structuredDataElement.parentNode.removeChild(structuredDataElement);
					return;
				}

				var structuredData = {
					'@context': 'https://schema.org',
					'@type': 'BlogPosting',
					headline: tagData.title || '',
					mainEntityOfPage: { '@type': 'WebPage', '@id': canonicalUrl },
				};
				if (tagData.description) structuredData.description = tagData.description;
				if (imageUrl) structuredData.image = imageUrl;
				if (datePublished) structuredData.datePublished = datePublished;
				if (dateModified) structuredData.dateModified = dateModified;
				if (author) structuredData.author = { '@type': 'Person', name: author };
				if (portalName) structuredData.publisher = { '@type': 'Organization', name: portalName };

				var estimatedTime = parseInt(tagData.estimatedTimeInMinutes, 10);
				if (estimatedTime > 0) structuredData.timeRequired = 'PT' + estimatedTime + 'M';

				if (!structuredDataElement) {
					structuredDataElement = document.createElement('script');
					structuredDataElement.id = 'blogposting-jsonld';
					structuredDataElement.type = 'application/ld+json';
					document.head.appendChild(structuredDataElement);
				}
				structuredDataElement.textContent = JSON.stringify(structuredData);
			}

			self.setMetaTags = function (tagData) {
				var title = tagData.title == null ? '' : tagData.title;
				var description = tagData.description == null ? '' : tagData.description;
				var keywords = tagData.keywords == null ? '' : tagData.keywords;

				$window.document.getElementsByName('title')[0].content = title;
				$window.document.getElementsByName('description')[0].content = description;
				$window.document.getElementsByName('keywords')[0].content = keywords;

				//Open graph...
				document.getElementById('og-title').content = title;
				document.getElementById('og-description').content = description;

				var imageUrl = tagData.img && tagData.img.length > 0 ? $filter('fullsitepath')(tagData.img) : defaultOgImage;
				ogImageElement.content = imageUrl;
				ogVideoElement.content =
					tagData.video && tagData.video.length > 0 ? $filter('fullsitepath')(tagData.video) : defaultOgVideo;

				var canonicalPath = tagData.canonicalPath || location.pathname;
				var canonicalUrl = canonicalOrigin + '/' + canonicalPath.replace(/^\/+|\/+$/g, '');
				document.getElementById('og-url').content = canonicalUrl;
				canonicalElement.href = canonicalUrl;
				document.getElementById('og-type').content = tagData.type || 'website';
				document.getElementById('robots-meta').content =
					portalSettings.IsPortalPublic === false
						? 'noindex, nofollow'
						: tagData.excludeFromExternalIndex
							? 'noindex, follow'
							: 'index, follow';
				setArticleMetadata(tagData, canonicalUrl, imageUrl);

				var documentTitle = title;
				if (!documentTitle) documentTitle = portalName || '';
				else if (portalName && documentTitle.trim().toLowerCase() !== portalName.trim().toLowerCase())
					documentTitle += ' - ' + portalName;
				$window.document.title = htmlDecode(documentTitle);
			};
		},
	]);

	baseService.$inject = ['$http', '$state', '$filter'];
	bizNotificationService.$inject = ['$timeout', '$mdToast'];
	bizPushNotificationBrowser.$inject = ['$window'];
	bizPushNotificationApi.$inject = ['$http'];
	bizPushNotificationService.$inject = [
		'$mdToast',
		'$q',
		'bizFirebaseMessagingClient',
		'bizPushNotificationBrowser',
		'bizPushNotificationApi',
	];
	bizRuntimeContainerService.$inject = ['container'];
	bizPageSurfaceService.$inject = ['$window'];

	function baseService($http, $state, $filter) {
		this.AddTranslatePartsToState = function (stateName, parts) {
			var state = $state.get(stateName);
			if (!state) return;

			if (!state.data) state.data = { translateParts: [] };
			else if (!state.data.translateParts) state.data.translateParts = [];

			state.data.translateParts = state.data.translateParts.concat(parts);
		};

		this.GetMenuItemsForLoggedInUser = function () {
			return $http.get(siteRootPath + 'api/menu/GetMenuItemsForLoggedInUser');
		};

		this.GetMenuBySystemName = function (systemName) {
			return $http
				.get(siteRootPath + 'api/menu/GetMenuBySystemName', { params: { systemName: systemName } })
				.then(function (response) {
					response.data.items = (response.data.items || []).map(mapMenuItemFromCamelCase);
					return response;
				});
		};

		function mapMenuItemFromCamelCase(item) {
			return {
				Id: item.id,
				Name: item.name,
				Link: item.link,
				Order: item.order,
				ParentId: item.parentId,
				CssClass: item.cssClass,
				CssClassAppMenu: item.cssClassAppMenu,
				ObjectId: item.objectId,
				ObjectType: item.objectType,
				ObjectIdentifier: item.objectIdentifier,
				ControllerScope: item.controllerScope,
				IsActive: item.isActive,
				IsDeleted: item.isDeleted,
				IsActiveInAppMenu: item.isActiveInAppMenu,
				IsExpandedByDefault: item.isExpandedByDefault,
				IsAnonymousOnly: item.isAnonymousOnly,
				Children: (item.children || []).map(mapMenuItemFromCamelCase),
			};
		}

		this.GetLoggedInUser = function () {
			return $http.get(siteRootPath + 'api/User/GetLoggedInUser');
		};

		this.GetCultures = function () {
			return $http.get(siteRootPath + 'api/culture/GetCultures');
		};

		this.HasLayoutComponent = function (type) {
			return $http.get(siteRootPath + 'api/layout/HasLayoutComponent', {
				params: {
					type: type,
				},
			});
		};

		this.GetGlobalSiteTitle = function () {
			return $http.get(siteRootPath + 'api/layout/GetGlobalSiteTitle');
		};

		this.GetFrontEndModuleSettingValue = function (module, key) {
			if (moduleSettings) {
				var settings = moduleSettings.GetItemByValue('ModuleName', module);
				if (settings && settings.Settings) {
					var s = settings.Settings.GetItemByValue('Key', key);
					return s ? s.Value : undefined;
				}
			}
			return undefined;
		};

		this.UpdateFrontEndModuleSettingValue = function (module, key, value) {
			if (moduleSettings) {
				var settings = moduleSettings.GetItemByValue('ModuleName', module);
				if (settings && settings.Settings) {
					var s = settings.Settings.GetItemByValue('Key', key);
					if (s) {
						s.Value = value;
					}
				}
			}
		};

		this.GetSiteRootPath = function (value) {
			return $filter('siteroot')(value);
		};
	}

	function bizNotificationService($timeout, $mdToast) {
		this.AddInformationNotification = function (header, body, timeout) {
			var guid = randomString(5);
			var html =
				'<div id="' +
				guid +
				'" class="bizNotificationItem"><div class="bizNotificationItem-header"><i class="fa-solid fa-info-circle info" aria-hidden="true"></i>' +
				header +
				'<i class="fa-solid fa-times close" aria-hidden="true"></i></div><div class="bizNotificationItem-body"><i class="fa-regular fa-circle-check" aria-hidden="true"></i><span>' +
				body +
				'</span></div></div>';
			var bizNotification = angular.element(document.querySelector('#bizNotification'));

			bizNotification.append(html);

			$timeout(
				function (id) {
					angular.element(document.querySelector('#' + id)).addClass('hide-notification');

					$timeout(
						function (elemId) {
							angular.element(document.querySelector('#' + elemId)).remove();
						},
						350,
						true,
						id
					);
				},
				timeout || 10000,
				true,
				guid
			);
		};

		this.AddCustomNotification = function (content) {
			var template = '<md-toast class="custom-notification">' + content + '</md-toast>';
			$mdToast.show({
				position: 'top center',
				parent: angular.element(document.body),
				hideDelay: 20000,
				template: template,
				autoWrap: true,
				controllerAs: 'vm',
				controller: function ($mdToast) {
					var vm = this;
					vm.close = function () {
						$mdToast.hide();
					};
				},
			});
		};

		function randomString(len) {
			var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
			var randomString = '';
			for (var i = 0; i < len; i++) {
				var randomPoz = Math.floor(Math.random() * charSet.length);
				randomString += charSet.substring(randomPoz, randomPoz + 1);
			}
			return randomString;
		}
	}

	function bizFirebaseMessagingClient() {
		return {
			deleteToken: deleteToken,
			getApps: getApps,
			getMessaging: getMessaging,
			getToken: getToken,
			initializeApp: initializeApp,
			isSupported: isSupported,
			onMessage: onMessage,
		};
	}

	function bizPushNotificationBrowser($window) {
		return {
			getLocalStorageItem: function (key) {
				return $window.localStorage.getItem(key);
			},
			getNotificationPermission: function () {
				return $window.Notification.permission;
			},
			hasRequiredApis: function () {
				return 'Notification' in $window && 'serviceWorker' in $window.navigator;
			},
			isIosDevice: function () {
				return (
					/iPad|iPhone|iPod/.test($window.navigator.userAgent) ||
					($window.navigator.platform === 'MacIntel' && $window.navigator.maxTouchPoints > 1)
				);
			},
			isStandalone: function () {
				return (
					$window.navigator.standalone === true ||
					($window.matchMedia && $window.matchMedia('(display-mode: standalone)').matches)
				);
			},
			navigate: function (url) {
				$window.location.href = url;
			},
			registerServiceWorker: function (url) {
				return $window.navigator.serviceWorker.register(url, { updateViaCache: 'none' });
			},
			requestNotificationPermission: function () {
				return $window.Notification.requestPermission();
			},
			setLocalStorageItem: function (key, value) {
				$window.localStorage.setItem(key, value);
			},
		};
	}

	function bizPushNotificationApi($http) {
		return {
			add: function (notificationId) {
				return $http.get(
					siteRootPath + 'api/PushNotification/AddPushNotificationId?' + $.param({ id: notificationId, type: 1 })
				);
			},
			remove: function (notificationId) {
				return $http.delete(siteRootPath + 'api/PushNotification/RemovePushNotificationId', {
					params: { notificationId: notificationId },
				});
			},
			validate: function (notificationId) {
				return $http.get(
					siteRootPath + 'api/PushNotification/ValidatePushNotificationId?' + $.param({ id: notificationId })
				);
			},
		};
	}

	function bizPushNotificationService($mdToast, $q, firebaseMessagingClient, pushNotificationBrowser, pushNotificationApi) {
		var VAPID_KEY = 'BJz2MR7KAppIhe0N3M4nX2VH6boXvxpXxdVcPUVDdSL8P7kGFe1s3pYNBhSol3SV22EOkDmbB7wa4uup0G2QUQE';
		var OPT_IN_STORAGE_KEY = 'bizpart.pushNotifications.optIn.v1';
		var messaging;
		var serviceWorkerRegistration;
		var supportPromise;
		var preparePromise;
		var initializePromise;
		var hasRegisteredOnMessage = false;
		var currentState = CreateState('loading');

		this.Initialize = RefreshStatus;
		this.GetStatus = RefreshStatus;
		this.InitializeReceiver = InitializeReceiver;

		async function InitializeReceiver() {
			// Receiving an existing subscription must not create or reassign an account's token.
			try {
				if (
					!pushNotificationBrowser.hasRequiredApis() ||
					pushNotificationBrowser.getNotificationPermission() !== 'granted' ||
					GetOptIn() === false ||
					(pushNotificationBrowser.isIosDevice() && !pushNotificationBrowser.isStandalone())
				)
					return;
				if (!(await IsFirebaseSupported())) return;
				await PrepareFirebase();
			} catch (error) {
				console.error('Could not initialize push notification reception.', error);
			}
		}

		function RefreshStatus() {
			if (!initializePromise) {
				var refreshPromise = $q.when(Initialize());
				initializePromise = refreshPromise;
				refreshPromise.then(
					function () {
						ClearInitializePromise(refreshPromise);
					},
					function () {
						ClearInitializePromise(refreshPromise);
					}
				);

				return refreshPromise;
			}

			return initializePromise;
		}

		function ClearInitializePromise(completedPromise) {
			if (initializePromise === completedPromise) {
				initializePromise = null;
			}
		}

		this.Enable = function () {
			if (pushNotificationBrowser.isIosDevice() && !pushNotificationBrowser.isStandalone()) {
				return $q.when(SetState('ios-install-required'));
			}

			if (!pushNotificationBrowser.hasRequiredApis()) {
				return $q.when(SetState('unsupported'));
			}

			var permission = pushNotificationBrowser.getNotificationPermission();
			var permissionPromise =
				permission === 'default' ? pushNotificationBrowser.requestNotificationPermission() : Promise.resolve(permission);

			return $q
				.when(permissionPromise)
				.then(function (permission) {
					if (permission === 'denied') {
						SetOptIn(false);
						return SetState('blocked');
					}

					if (permission !== 'granted') {
						return SetState('disabled');
					}

					SetOptIn(true);
					return PrepareFirebase().then(SynchronizeToken);
				})
				.catch(HandleError);
		};

		this.Disable = function () {
			SetOptIn(false);

			if (!pushNotificationBrowser.hasRequiredApis() || pushNotificationBrowser.getNotificationPermission() !== 'granted') {
				return $q.when(SetState('disabled'));
			}

			return $q
				.when(PrepareFirebase())
				.then(function () {
					return firebaseMessagingClient.getToken(messaging, GetTokenOptions());
				})
				.then(function (token) {
					var removePromise = token ? pushNotificationApi.remove(token) : $q.when();

					return removePromise.finally(function () {
						return firebaseMessagingClient.deleteToken(messaging);
					});
				})
				.then(function () {
					return SetState('disabled');
				})
				.catch(function (error) {
					console.error('Could not completely remove the push notification subscription.', error);
					return SetState('disabled');
				});
		};

		async function Initialize() {
			if (pushNotificationBrowser.isIosDevice() && !pushNotificationBrowser.isStandalone()) {
				return SetState('ios-install-required');
			}

			if (!pushNotificationBrowser.hasRequiredApis()) {
				return SetState('unsupported');
			}

			try {
				if (!(await IsFirebaseSupported())) {
					return SetState('unsupported');
				}
			} catch (error) {
				return HandleError(error);
			}

			if (pushNotificationBrowser.getNotificationPermission() === 'denied') {
				SetOptIn(false);
				return SetState('blocked');
			}

			if (pushNotificationBrowser.getNotificationPermission() !== 'granted') {
				return SetState('disabled');
			}

			var optIn = GetOptIn();
			if (optIn === null) {
				// Preserve subscriptions created by the previous Firebase implementation.
				SetOptIn(true);
				optIn = true;
			}

			if (!optIn) {
				return SetState('disabled');
			}

			try {
				await PrepareFirebase();
				return await SynchronizeToken();
			} catch (error) {
				return HandleError(error);
			}
		}

		function PrepareFirebase() {
			if (!preparePromise) {
				var preparationPromise = IsFirebaseSupported()
					.then(function (supported) {
						if (!supported) {
							var unsupportedError = new Error('Firebase messaging is not supported in this browser.');
							unsupportedError.pushNotificationState = 'unsupported';
							throw unsupportedError;
						}

						var apps = firebaseMessagingClient.getApps();
						var firebaseApp = apps.length > 0 ? apps[0] : firebaseMessagingClient.initializeApp(firebaseConfig);
						messaging = firebaseMessagingClient.getMessaging(firebaseApp);

						if (!hasRegisteredOnMessage) {
							firebaseMessagingClient.onMessage(messaging, function (payload) {
								ReportPushReceipt(payload, 'foreground_received');
								if (payload && payload.data && payload.data.show_on_site === 'True') {
									ShowOnSite(payload);
								} else if (payload && payload.data) {
									return ShowSystemNotification(payload);
								}
							});
							hasRegisteredOnMessage = true;
						}

						return pushNotificationBrowser.registerServiceWorker(siteRootPath + 'firebase-messaging-sw.js');
					})
					.then(function (registration) {
						serviceWorkerRegistration = registration;
						return registration;
					});

				preparePromise = preparationPromise.catch(function (error) {
					preparePromise = null;
					throw error;
				});
			}

			return preparePromise;
		}

		function IsFirebaseSupported() {
			if (!supportPromise) {
				supportPromise = firebaseMessagingClient.isSupported();
			}

			return supportPromise;
		}

		async function SynchronizeToken() {
			var currentToken = await firebaseMessagingClient.getToken(messaging, GetTokenOptions());
			if (!currentToken) {
				throw new Error('Firebase did not return a registration token.');
			}

			var valid = await pushNotificationApi.validate(currentToken);
			if (!valid.data) {
				await pushNotificationApi.add(currentToken);
			}

			return SetState('enabled');
		}

		function GetTokenOptions() {
			return {
				vapidKey: VAPID_KEY,
				serviceWorkerRegistration: serviceWorkerRegistration,
			};
		}

		function GetOptIn() {
			try {
				var value = pushNotificationBrowser.getLocalStorageItem(OPT_IN_STORAGE_KEY);
				return value === null ? null : value === 'true';
			} catch (error) {
				return null;
			}
		}

		function SetOptIn(value) {
			try {
				pushNotificationBrowser.setLocalStorageItem(OPT_IN_STORAGE_KEY, value.toString());
			} catch (error) {
				console.warn('Could not persist push notification preference.', error);
			}
		}

		function HandleError(error) {
			if (error && error.pushNotificationState === 'unsupported') {
				return SetState('unsupported');
			}

			console.error('Push notification registration failed.', error);
			return SetState('error', error);
		}

		function CreateState(status, error) {
			return { status: status, error: error || null };
		}

		function SetState(status, error) {
			currentState = CreateState(status, error);
			return currentState;
		}

		async function ShowSystemNotification(payload) {
			try {
				// A message can arrive while the worker registration is still being prepared.
				var registration = serviceWorkerRegistration || (await PrepareFirebase());
				await registration.showNotification(payload.data.title, {
					body: payload.data.body,
					icon: payload.data.icon,
					tag: payload.data.tag,
					// Use the worker's existing click navigation and receipt handler.
					data: { url: payload.data.url, diagnostic_token: payload.data.diagnostic_token },
				});
				ReportPushReceipt(payload, 'display_succeeded');
			} catch (error) {
				ReportPushReceipt(payload, 'display_failed', error && error.name);
			}
		}

		function ReportPushReceipt(payload, stage, errorName) {
			// Diagnostics must never interrupt a foreground notification or its navigation.
			var timeout;
			var controller;
			try {
				var token = payload && payload.data && payload.data.diagnostic_token;
				if (!token) return;
				timeout = setTimeout(function () {
					try {
						if (controller) controller.abort();
					} catch (error) {
						/* best effort */
					}
				}, 5000);
				if (typeof AbortController !== 'undefined') controller = new AbortController();
				var request = {
					method: 'POST',
					credentials: 'omit',
					keepalive: true,
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ token: token, stage: stage, errorName: errorName }),
				};
				if (controller) request.signal = controller.signal;
				Promise.resolve(fetch(siteRootPath + 'api/PushDiagnostic/Record', request)).then(
					function () {
						clearTimeout(timeout);
					},
					function () {
						clearTimeout(timeout);
					}
				);
			} catch (error) {
				clearTimeout(timeout);
			}
		}

		function ShowOnSite(payload) {
			var template =
				'<md-toast class="push-toast" ng-click="vm.click()">' +
				payload.data.body +
				'<i class="fas fa-times" ng-click="vm.close()" /></md-toast>';
			$mdToast.show({
				position: 'top center',
				parent: angular.element(document.body),
				hideDelay: 10000,
				template: template,
				autoWrap: true,
				controllerAs: 'vm',
				controller: function ($mdToast) {
					var vm = this;
					vm.close = function () {
						$mdToast.hide();
					};
					vm.click = function () {
						ReportPushReceipt(payload, 'clicked');
						if (payload.data.click_action) {
							pushNotificationBrowser.navigate(payload.data.click_action);
						}
					};
				},
			});
		}
	}

	function bizRuntimeContainerService(container) {
		this.PrepareContainer = function (runtimeContainer) {
			var isV2 = this.IsContainerV2(runtimeContainer);

			return {
				Container: isV2 || !runtimeContainer ? runtimeContainer : new container(runtimeContainer),
				IsV2: isV2,
				Version: this.GetContainerVersion(runtimeContainer, isV2),
			};
		};

		this.IsContainerV2 = function (runtimeContainer) {
			return !!(
				runtimeContainer &&
				(runtimeContainer.placeholders || runtimeContainer.Version > 1 || runtimeContainer.version > 1)
			);
		};

		this.GetContainerVersion = function (runtimeContainer, isContainerV2) {
			if (!runtimeContainer) {
				return 1;
			}

			if (runtimeContainer.Version > 1 || runtimeContainer.version > 1) {
				return runtimeContainer.Version || runtimeContainer.version;
			}

			return isContainerV2 ? 2 : 1;
		};

		this.GetImageUrl = function (runtimeContainer, containerVersion) {
			if (containerVersion >= 2) {
				return getContainerV2MediaUrl(runtimeContainer, 'IMAGE', ['src', 'Src', 'imageUrl', 'ImageUrl']);
			}

			return getLegacyModuleContentValue(runtimeContainer, 'IMAGE', 'ImageUrl');
		};

		this.GetVideoUrl = function (runtimeContainer, containerVersion) {
			if (containerVersion >= 2) {
				return getContainerV2MediaUrl(runtimeContainer, 'VIDEO', ['videoUrl', 'VideoUrl']);
			}

			return getLegacyModuleContentValue(runtimeContainer, 'VIDEO', 'VideoUrl');
		};

		function getLegacyModuleContentValue(legacyContainer, moduleType, contentKey) {
			if (!legacyContainer || !legacyContainer.getModules) {
				return '';
			}

			var modules = legacyContainer.getModules(moduleType);
			if ((!modules || modules.length === 0) && moduleType.length > 0) {
				modules = legacyContainer.getModules(moduleType.charAt(0) + moduleType.slice(1).toLowerCase());
			}

			if (!modules || modules.length === 0 || !modules[0].Content) {
				return '';
			}

			var value = modules[0].Content[contentKey];
			return value && value.length > 0 ? value : '';
		}

		function getContainerV2MediaUrl(containerData, moduleType, contentKeys) {
			var placeholders = containerData ? containerData.placeholders || containerData.Placeholders : null;
			if (!placeholders) {
				return '';
			}

			for (var i = 0; i < placeholders.length; i++) {
				var imageUrl = getFirstContainerV2MediaUrl(
					placeholders[i].modules || placeholders[i].Modules || [],
					moduleType,
					contentKeys
				);
				if (imageUrl) {
					return imageUrl;
				}
			}

			return '';
		}

		function getFirstContainerV2MediaUrl(modules, moduleType, contentKeys) {
			for (var i = 0; i < modules.length; i++) {
				var module = modules[i] || {};
				var currentModuleType = module.moduleType || module.ModuleType || module.type || module.Type;
				var content = module.content || module.Content || {};

				if (currentModuleType && currentModuleType.toUpperCase() === moduleType) {
					for (var j = 0; j < contentKeys.length; j++) {
						var value = content[contentKeys[j]];
						if (value && value.length > 0) {
							return value;
						}
					}
				}

				var childImageUrl = getFirstContainerV2MediaUrl(
					module.children || module.Children || [],
					moduleType,
					contentKeys
				);
				if (childImageUrl) {
					return childImageUrl;
				}
			}

			return '';
		}
	}

	function bizPageSurfaceService($window) {
		var contentTargetSelector = '#base-home';
		var footerTargetSelector = '.biz-wrapper-outer';
		var classNames = [
			'has-page-surface',
			'page-surface-width-content',
			'page-surface-width-viewport',
			'page-surface-attachment-fixed',
		];
		var cssVariables = [
			'--biz-page-surface-width',
			'--biz-page-surface-top',
			'--biz-page-surface-height',
			'--biz-page-surface-color',
			'--biz-page-surface-image',
			'--biz-page-surface-position',
			'--biz-page-surface-size',
			'--biz-page-surface-repeat',
			'--biz-page-surface-attachment',
		];
		var currentTarget = null;
		var resizeObserver = null;
		var resizeHandler = null;
		var pendingAnimationFrame = null;

		this.ApplyFromContainer = function (runtimeContainer) {
			var pageSurface = getPageSurface(runtimeContainer);

			if (!pageSurface || pageSurface.enabled !== true) {
				this.Clear();
				return;
			}

			var target = document.querySelector(getTargetSelector(pageSurface));
			if (!target) {
				return;
			}

			this.Clear();
			currentTarget = target;

			var background = pageSurface.background || {};
			target.classList.add('has-page-surface');
			target.classList.add(pageSurface.width === 'content' ? 'page-surface-width-content' : 'page-surface-width-viewport');
			if (background.attachment === 'fixed') {
				target.classList.add('page-surface-attachment-fixed');
			}
			target.style.setProperty('--biz-page-surface-color', getCssColorValue(background.color));
			target.style.setProperty('--biz-page-surface-image', getCssImageValue(background));
			target.style.setProperty(
				'--biz-page-surface-position',
				(background.positionX || 'center') + ' ' + (background.positionY || 'top')
			);
			target.style.setProperty('--biz-page-surface-size', background.size || 'cover');
			target.style.setProperty('--biz-page-surface-repeat', background.repeat || 'no-repeat');
			target.style.setProperty('--biz-page-surface-attachment', background.attachment || 'scroll');

			setSurfaceHeight(pageSurface);
			bindResizeHandlers(pageSurface);
		};

		this.Clear = function () {
			if (resizeHandler) {
				$window.removeEventListener('resize', resizeHandler);
				resizeHandler = null;
			}

			if (resizeObserver) {
				resizeObserver.disconnect();
				resizeObserver = null;
			}

			if (pendingAnimationFrame) {
				$window.cancelAnimationFrame(pendingAnimationFrame);
				pendingAnimationFrame = null;
			}

			var targets = getTargetsToClear();
			for (var i = 0; i < targets.length; i++) {
				for (var j = 0; j < classNames.length; j++) {
					targets[i].classList.remove(classNames[j]);
				}

				for (var k = 0; k < cssVariables.length; k++) {
					targets[i].style.removeProperty(cssVariables[k]);
				}
			}

			currentTarget = null;
		};

		function bindResizeHandlers(pageSurface) {
			resizeHandler = function () {
				requestSurfaceHeightUpdate(pageSurface);
			};

			$window.addEventListener('resize', resizeHandler);

			if ('ResizeObserver' in $window) {
				resizeObserver = new $window.ResizeObserver(function () {
					requestSurfaceHeightUpdate(pageSurface);
				});

				resizeObserver.observe(currentTarget);

				var footer = document.querySelector('footer');
				if (footer) {
					resizeObserver.observe(footer);
				}
			}

			$window.setTimeout(function () {
				setSurfaceHeight(pageSurface);
			}, 0);
			$window.setTimeout(function () {
				setSurfaceHeight(pageSurface);
			}, 250);
		}

		function requestSurfaceHeightUpdate(pageSurface) {
			if (pendingAnimationFrame) {
				return;
			}

			pendingAnimationFrame = $window.requestAnimationFrame(function () {
				pendingAnimationFrame = null;
				setSurfaceHeight(pageSurface);
			});
		}

		function setSurfaceHeight(pageSurface) {
			if (!currentTarget) {
				return;
			}

			if (pageSurface.extendToFooter === false) {
				currentTarget.style.setProperty('--biz-page-surface-top', '0');
				currentTarget.style.setProperty('--biz-page-surface-height', '100%');
				return;
			}

			var footer = document.querySelector('footer');
			if (!footer) {
				currentTarget.style.setProperty('--biz-page-surface-top', '0');
				currentTarget.style.setProperty('--biz-page-surface-height', '100%');
				return;
			}

			var surfaceStart = document.querySelector(contentTargetSelector) || currentTarget;
			var scrollTop = $window.pageYOffset || document.documentElement.scrollTop || 0;
			var targetTop = currentTarget.getBoundingClientRect().top + scrollTop;
			var surfaceTop = surfaceStart.getBoundingClientRect().top + scrollTop;
			var footerTop = footer.getBoundingClientRect().top + scrollTop;
			var topOffset = Math.max(surfaceTop - targetTop, 0);
			var height = Math.max(surfaceStart.offsetHeight || 0, footerTop - surfaceTop);

			currentTarget.style.setProperty('--biz-page-surface-top', topOffset + 'px');
			currentTarget.style.setProperty('--biz-page-surface-height', Math.max(height, 0) + 'px');
		}

		function getPageSurface(runtimeContainer) {
			var style = runtimeContainer ? runtimeContainer.style || runtimeContainer.Style : null;
			return style ? style.pageSurface || style.PageSurface : null;
		}

		function getTargetSelector(pageSurface) {
			return pageSurface.extendToFooter === false ? contentTargetSelector : footerTargetSelector;
		}

		function getTargetsToClear() {
			var targets = [];
			addTargetToClear(targets, currentTarget);
			addTargetToClear(targets, document.querySelector(contentTargetSelector));
			addTargetToClear(targets, document.querySelector(footerTargetSelector));
			return targets;
		}

		function addTargetToClear(targets, target) {
			if (!target || targets.indexOf(target) !== -1) {
				return;
			}

			targets.push(target);
		}

		function getCssColorValue(color) {
			if (!color || isCssGradient(color)) {
				return 'transparent';
			}

			return color;
		}

		function getCssImageValue(background) {
			var layers = [];

			if (background.color && isCssGradient(background.color)) {
				layers.push(background.color);
			}

			if (background.imageUrl) {
				layers.push('url("' + escapeCssUrl(getRootedPath(background.imageUrl)) + '")');
			}

			return layers.length > 0 ? layers.join(', ') : 'none';
		}

		function isCssGradient(value) {
			return typeof value === 'string' && /gradient\s*\(/i.test(value);
		}

		function getRootedPath(path) {
			if (!path || path.toLowerCase().indexOf('http') === 0 || path.indexOf('data:') === 0) {
				return path;
			}

			var normalized = path.replace('##UPLOAD##/', portalUploadPath || '');

			if (normalized.charAt(0) === '~') {
				normalized = normalized.substring(1);
			}

			if (normalized.charAt(0) === '/') {
				normalized = normalized.substring(1);
			}

			return siteRootPath + normalized;
		}

		function escapeCssUrl(value) {
			return value
				.replace(/\\/g, '\\\\')
				.replace(/"/g, '\\"')
				.replace(/\n|\r|\f/g, '');
		}
	}
})(window.angular);
